import {PlotChartOptions} from "./structs";

export class Helper {
    constructor() {
    }

    public removeFileSystemChars(str: string, removeDots = true, replacement: string = "") {
        str = str.replace(new RegExp("[/<>:\"\\\\\|\?\*]", "g"), replacement);
        if (removeDots === true) // replace dots by spaces to keep the file extension
            str = str.replace(/\./g, " ");
        return str;
    }

    public getHistoryLineChartOpts(xAxisRotation: number = 0.0) {
        var opts = new PlotChartOptions();
        if (xAxisRotation !== 0.0)
            opts.xAxisRotation = xAxisRotation;
        opts.colors = [
            "#2ca2fb", // Tweets
            "#ff7142", // Reddit
            "#330ee6", // Telegram
            "#c5d4dd", // News
            "#ff1e23", // Price
            "#18bf23", // Sentiment
            "#00001a" // Wolf Rating
        ];
        //opts.noDataTxt = i18next.t('noDataAvailable');
        opts.noDataTxt = "No data available";
        opts.hideLabels = true;
        return opts;
    }
}